import builder from '../builder';
import Pin from '../../streamline-icons/bold/pin.svg';

export default builder('IconPinBold', Pin);
